import React, { FC, memo, useMemo } from 'react';
import classNames from 'classnames';
import { isNaN, isUndefined } from 'lodash';

import SongsBlockInfo from './SongsBlockInfo';
import NotesBlockInfo from './NotesBlockInfo';
import QuestionsBlockInfo from './QuestionsBlockInfo';
import ProgressCircle from 'components/common/ProgressCircle';

import { SectionBlocksInfoProps } from './interfaces';

import useStyles from '../style';

const SectionBlocksInfo: FC<SectionBlocksInfoProps> = ({
  progress,
  showSongsInfo,
  showNotesInfo,
  showQuestionsInfo,
}) => {
  const classes = useStyles();

  const isInfoPresent = useMemo(() => showSongsInfo || showQuestionsInfo || showNotesInfo, [
    showSongsInfo,
    showQuestionsInfo,
    showNotesInfo,
  ]);

  return isInfoPresent ? (
    <div className={classNames('iconsWrapper', classes.iconsWrapper)}>
      {isUndefined(progress) || isNaN(progress) ? null : (
        <ProgressCircle progress={progress} className="blockInfo" />
      )}
      {showSongsInfo ? <SongsBlockInfo /> : null}
      {showQuestionsInfo ? <QuestionsBlockInfo /> : null}
      {showNotesInfo ? <NotesBlockInfo /> : null}
    </div>
  ) : null;
};

export default memo(SectionBlocksInfo);
